/**
 * @Author: v_jppjpeng
 * @Date: 2023-08-31 09:19:43
 * @Explain: 气泡提示
 */
import { Icon, Link, Tooltip } from '@/components/tdesign';
import classNames from 'classnames';
import type { CSSProperties, ReactElement, ReactNode } from 'react';
import type { LinkProps, TooltipProps } from 'tdesign-react';
// utils
import { isArray, isArrayLen } from '@/utils/common/dataJudgment';
import { filteringHtmlScripts } from '@/utils/domPurify';

export type PropsType = {
  className?: string;
  style?: CSSProperties;
  /** 展示xx时间后关闭 */
  duration?: number;
  /** 是否展示三角 */
  showArrow?: boolean;
  /** 主题 */
  theme?: TooltipProps['theme'];
  /** 方位 */
  placement?: TooltipProps['placement'];
  /** 位移
   * [num1, num2]
   * num1: 上下
   * num2: 左右
   */
  placementOffset?: any[];
  /** 容器最小宽度 */
  minWidth?: any;
  /** 容器最大宽度 */
  maxWidth?: any;
  /** popup props  */
  tooltipProps?: TooltipProps;
  /** 前置 */
  prefixEl?: ReactElement | string;
  /** 中间 */
  iconName?: string;
  iconFontSize?: number;
  middleEl?: ReactElement | string;
  middleClassName?: any;
  middleStyle?: CSSProperties;
  middleTheme?: LinkProps['theme'];
  /** 后置 */
  suffixEl?: ReactElement | string;
  /** 简介模式 */
  descClassName?: string;
  descStyle?: CSSProperties;
  descList?: any;
  descTitle?: string;
  /** 自定义内容 */
  customContent?: ReactNode | any;
  onClick?: LinkProps['onClick'];
};
export default function BubbleDesc(props: PropsType) {
  const {
    className,
    style,
    theme,
    showArrow = true,
    duration,
    placement,
    placementOffset,
    maxWidth,
    minWidth,
    tooltipProps,
    prefixEl,
    iconName = 'question-mark',
    iconFontSize = 24,
    middleEl,
    middleClassName,
    middleStyle,
    middleTheme = 'default',
    suffixEl,
    customContent,
    descTitle,
    descList,
    onClick,
  } = props;

  function desc() {
    return isArrayLen(descList) ? (
      <div className="bubble-desc">
        {descTitle && <h1>{descTitle}</h1>}
        <div className="content">
          {isArray(descList) &&
            descList?.map((item: any, index: number) => (
              <dl key={index.toString()}>
                {item.label && (
                  <dt>
                    <i className="dot">·</i> {item.label}
                  </dt>
                )}
                {isArray(item.content) &&
                  item.content.map((subItem: any, subIndex: number) => (
                    <dd
                      key={`sub-${subIndex}`}
                      dangerouslySetInnerHTML={{
                        __html: filteringHtmlScripts(subItem),
                      }}
                    />
                  ))}
              </dl>
            ))}
        </div>
      </div>
    ) : (
      ''
    );
  }
  return (
    <Tooltip
      overlayClassName={classNames('default-td-bubble-desc', className)}
      theme={theme}
      showArrow={showArrow}
      duration={duration}
      placement={placement}
      placementOffset={placementOffset}
      maxWidth={maxWidth}
      minWidth={minWidth}
      content={customContent ? customContent : desc()}
      tooltipProps={tooltipProps}
    >
      <div className="bubble-desc-show-text" style={style}>
        {prefixEl}
        {middleEl || (
          <Link
            className={classNames(
              'middle-el',
              { 'link-icon': middleTheme === 'default' },
              middleClassName,
            )}
            theme={middleTheme}
            style={middleStyle}
            onClick={onClick}
          >
            <Icon.Font name={iconName} fontSize={iconFontSize} />
          </Link>
        )}
        {suffixEl}
      </div>
    </Tooltip>
  );
}
